<template>
  <div>
    <div class="inline-block pr-4 pb-4 w-1/2">
      <p
        class="align-top font-semibold font-sans leading-snug subpixel-antialiased text-base text-black"
      >
        {{ label }}
      </p>
    </div>
    <div class="inline-block pb-4 w-1/2">
      <p
        v-if="value"
        class="align-top font-light font-sans leading-none subpixel-antialiased text-base text-black"
      >
        {{ value }}
      </p>
      <p
        v-else
        class="align-top font-light font-sans leading-none subpixel-antialiased text-base"
      >
        Not provided
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "DoeCellNumber",
  props: {
    name: {
      type: String,
      required: true
    },
    label: {
      type: String
    },
    value: {
      type: String
    }
  },
};
</script>

<style lang="scss" scoped></style>
